var exports = {
  "kL": "xfd349460--7ace78--container",
  "aY": "xfd349460--7ace78--code",
  "h_": "xfd349460--7ace78--description",
  "SD": "xfd349460--7ace78--static-preview",
};

module.exports = exports;
